<p class="ki-ergebnis-abgelaufen" role="status" data-testid="ki-ergebnis-abgelaufen">
  {{ 'ki.ergebnisAbgelaufen.hinweis' | translate }}
</p>
